// Module
var code = "<a class=\"cr-uppercase delete-link\" data-global-qa-id=\"delete-link\" ng-class=\"$ctrl.customClass\" ng-click=\"$ctrl.deleteEntity($ctrl.type, $ctrl.entity)\">{{ ::$ctrl.getDeleteText() }}</a> ";
// Exports
export default code;